import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueCarousel from 'vue-carousel';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ProductCarousel from 'vue-product-carousel'
import VueRouter from "vue-router";
import router from './router'
import VueGtag from "vue-gtag";
import vueHljs from "vue-hljs";
//if you want to use default color, import this css file
import "vue-hljs/dist/vue-hljs.min.css";
library.add(faUserSecret, faAngleDoubleDown)

Vue.use(VueCarousel);
Vue.component('VueSlider', VueSlider)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('ProductCarousel', ProductCarousel)
Vue.use(vueHljs)

Vue.use(VueGtag, {
  config: { id: "UA-176997559-1" }
});

Vue.config.productionTip = false
Vue.use(VueRouter);

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
